import { Component, OnInit } from '@angular/core';
import { ReferenceDataLabels } from 'rome-library';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'boi-privacy-policy',
  templateUrl: './privacy-policy.component.html'
})
export class PrivacyPolicyComponent implements OnInit {
  public readonly referenceDataLabels = ReferenceDataLabels;

  constructor(private readonly headerService: HeaderService) {}

  ngOnInit(): void {
    this.headerService.setHeaderTitle('');
  }
}
